<form nz-form [formGroup]="observacoesForm" (ngSubmit)="salvarObservacoes()">
  <div class="row">
    <div class="col-sm-12">
      <nz-form-item>
        <nz-form-label [nzSm]="4" nzFor="textoObservacao" class="form-label">Observações</nz-form-label>
        <nz-form-control [nzSm]="20">
          <textarea nz-input rows="4" formControlName="textoObservacao" [disabled]="editar"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div class="row justify-content-end mt-3">
    <div class="col-sm-auto">
      <nz-form-item>
        <nz-form-control [nzOffset]="4" [nzSm]="20">
          <button nz-button nzType="default" type="button" (click)="fecharModal()">Cancelar</button>
          <button nz-button nzType="primary" type="submit" [disabled]="observacoesForm.invalid" class="ms-2">Adicionar</button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</form>
